function initVariantSwatches() {
  const swatchList = document.querySelector('[data-swatch-list]');
  if (!swatchList) return;

  const container = swatchList.querySelector('[data-swatch-scroll-container]');
  const grid = swatchList.querySelector('[data-swatch-grid]');
  if (!container || !grid) return;

  let lastContainerWidth = 0;
  let expandController = null;

  const showAll = () => {
    for (const swatch of swatchList.querySelectorAll('[data-variant-swatch]')) {
      swatch.classList.remove('hidden');
      swatch.querySelector('[data-swatch-image-wrapper] img')?.classList.remove('blur-sm');
      const overlay = swatch.querySelector('[data-swatch-overlay]');
      if (overlay) {
        overlay.classList.remove('flex');
        overlay.classList.add('hidden');
        overlay.querySelector('[data-swatch-count]').textContent = '';
      }
    }
  };

  const calculateOverflow = () => {
    const swatches = [...swatchList.querySelectorAll('[data-variant-swatch]')];
    if (!swatches.length) return;

    expandController?.abort();
    showAll();
    container.classList.remove('overflow-x-auto', 'scrollbar-hide');
    container.classList.add('overflow-hidden');

    lastContainerWidth = Math.round(container.offsetWidth);

    const swatchWidth = swatches[0].offsetWidth;
    const gap = parseFloat(getComputedStyle(grid).columnGap) || 8;
    const fitCount = Math.floor((container.offsetWidth + gap) / (swatchWidth + gap));

    if (fitCount >= swatches.length) return;

    swatches.slice(fitCount).forEach((s) => s.classList.add('hidden'));

    const lastVisible = swatches[fitCount - 1];
    const overflowCount = swatches.length - fitCount + 1;

    lastVisible.querySelector('[data-swatch-image-wrapper] img')?.classList.add('blur-sm');

    const overlay = lastVisible.querySelector('[data-swatch-overlay]');
    if (overlay) {
      overlay.querySelector('[data-swatch-count]').textContent = `+${overflowCount}`;
      overlay.classList.remove('hidden');
      overlay.classList.add('flex');
    }

    lastVisible.setAttribute('aria-label', `Show ${overflowCount} more colour options`);

    expandController = new AbortController();
    lastVisible.addEventListener('click', () => {
      showAll();
      container.classList.remove('overflow-hidden');
      container.classList.add('overflow-x-auto', 'scrollbar-hide');
      lastContainerWidth = Math.round(container.offsetWidth);
      const { colorValue } = lastVisible.dataset;
      if (colorValue) lastVisible.setAttribute('aria-label', `Select ${colorValue}`);
    }, { once: true, signal: expandController.signal });
  };

  calculateOverflow();

  new ResizeObserver((entries) => {
    const width = Math.round(entries[0]?.contentRect.width ?? 0);
    if (width !== lastContainerWidth) calculateOverflow();
  }).observe(container);
}

document.addEventListener('DOMContentLoaded', initVariantSwatches);
